import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import PageLayout from '@/widgets/PageLayout';

import { ContentType } from '@/common/constants/ContentTypes';
import ProductStore from '@/stores/ProductStore';
import {
  ContainerWrapper,
  ContainerBlogPageStyled,
} from './BlogPostPage.styles';
import { SectionByContent } from '../../constants/SectionByContent';
import { BlogContentType } from '../../types';
import { WhatIsOVSection } from '../../components/WhatIsOVSection/WhatIsOVSection';
import { SectionByName } from './SectionByName/SectionByName';

interface BlogPostPageProps {
  contentType: ContentType;
  resource: BlogContentType;
}

const BlogPostPage = ({
  resource,
  contentType,
}: BlogPostPageProps): JSX.Element => {
  const commentsRef = useRef<HTMLDivElement>(null);
  const { resourceType } = resource || {};
  const { type } = resourceType || { type: null };
  const { currentVariant } = ProductStore;

  const handleToCommentsClick = () => {
    if (commentsRef.current) {
      commentsRef.current.scrollIntoView();
    }
  };

  useEffect(() => {
    if (contentType === ContentType.PRODUCTS) {
      ProductStore.setCurrentOption(resource.options?.[0]);
      ProductStore.setCurrentVariant(resource.variants?.[0]);
    }
  }, [contentType, resource.options, resource.variants]);

  return (
    <PageLayout>
      <ContainerBlogPageStyled>
        <ContainerWrapper contentType={contentType}>
          {SectionByContent[contentType][type]?.map((section) => (
            <SectionByName
              key={section}
              content={resource}
              sectionName={section}
              contentType={contentType}
              currentVariant={currentVariant}
              commentsRef={commentsRef}
              toCommentsClick={handleToCommentsClick}
            />
          ))}
          <WhatIsOVSection />
        </ContainerWrapper>
      </ContainerBlogPageStyled>
    </PageLayout>
  );
};

export default observer(BlogPostPage);
